import { render, staticRenderFns } from "./LayoutContentOnboarding.vue?vue&type=template&id=6e3a2f0c&scoped=true&"
import script from "./LayoutContentOnboarding.vue?vue&type=script&lang=js&"
export * from "./LayoutContentOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./LayoutContentOnboarding.vue?vue&type=style&index=0&id=6e3a2f0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3a2f0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VMain } from 'vuetify/lib/components/VMain';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VApp,VCol,VFooter,VMain,VOverlay,VSystemBar})
